<template>
  <div class="newProductRecordItem" @click="godetail">
    <div class="time flex-js-ac">
      <div
        class="countdown flex-ac"
        :class="{
          red: productItem.status == 1,
          yellow:
            productItem.status == 2 ||
            (productItem.status == 3 && productItem.giftstatus != 0) ||
            productItem.status == 4,
          orange: productItem.status == 3 && productItem.giftstatus == 0
        }"
      >
        <p class="f12 flex-ac">
          <van-icon name="clock-o" size="0.13rem" color="#ffffff" />
          {{
            productItem.status == 1
              ? '进行中'
              : productItem.status == 2 ||
                (productItem.status == 3 && productItem.giftstatus != 0) ||
                productItem.status == 4
              ? '已结束'
              : '已开奖'
          }}
        </p>
        <div class="f12 flex-ac">
          <span>
            {{
              productItem.status == 1
                ? '距结束还剩'
                : productItem.status == 3 && productItem.giftstatus == 0
                ? '非常遗憾，未能申请成功'
                : productItem.time
            }}
          </span>
          <van-count-down
            v-if="productItem.status == 1"
            @finish="finishFn"
            :time="productItem.countdown"
          />
          <span
            v-if="
              productItem.status == 2 ||
              (productItem.status == 3 && productItem.giftstatus != 0) ||
              productItem.status == 4
            "
          >
            截止
          </span>
        </div>
      </div>
      <span
        class="f12"
        :class="{
          red: productItem.status == 1 || (productItem.status == 3 && productItem.giftstatus != 0),
          yellow: productItem.status == 2,
          orange: productItem.status == 3 && productItem.giftstatus == 0,
          gray: productItem.status == 4
        }"
      >
        {{
          productItem.status == 1
            ? '已申请'
            : productItem.status == 2
            ? '待开奖'
            : productItem.status == 3 && productItem.giftstatus == 0
            ? '未中奖'
            : productItem.status == 4
            ? '已过期'
            : '已中奖'
        }}
      </span>
    </div>
    <div class="product flex-ac">
      <img class="flex-s" :src="productItem.image_path" />
      <div class="name flex-1">
        <p class="f14 over-ell-2">{{ productItem.itemname }}</p>
        <span v-if="!(productItem.status == 3 && productItem.giftstatus == 3)" class="f12">
          仅限{{ productItem.limitnum }}份&nbsp;&nbsp;&nbsp;价值:¥{{ productItem.costprice }}
        </span>
        <button
          v-if="productItem.status == 3 && productItem.giftstatus == 3"
          @click.stop="btnFn1"
          class="f12 yellow-border"
          style="right: 0.82rem"
        >
          查看反馈
        </button>
        <button
          v-if="productItem.status == 3 && productItem.giftstatus != 0"
          @click.stop="btnFn"
          class="f12"
          :class="{
            red: productItem.giftstatus == 1,
            yellow: productItem.giftstatus == 2 || productItem.giftstatus == 3
          }"
        >
          {{
            productItem.giftstatus == 1
              ? '领取'
              : productItem.giftstatus == 2 || productItem.giftstatus == 3
              ? '试用反馈'
              : ''
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newProductRecordItem',
  props: {
    productItem: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    godetail() {
      this.$router.push({
        path: '/newproductdetail',
        query: {
          id: this.productItem.actid
        }
      })
    },
    finishFn() {
      this.$emit('finish')
    },
    btnFn1() {
      this.$router.push({
        path: '/community'
      })
    },
    btnFn() {
      if (this.productItem.giftstatus == 1) {
        let productInfo = {
          applyid: this.productItem.applyid,
          itemid: this.productItem.itemid,
          name: this.productItem.itemname,
          skuid: this.productItem.skuid,
          spec: this.productItem.spec,
          price: this.productItem.saleprice,
          integral: 0,
          integralcount: 0,
          img_path: this.productItem.image_path,
          num: 1,
          totalprice: '0.00'
        }
        localStorage.setItem('productInfo', JSON.stringify(productInfo))
        this.$router.push({
          path: '/addOrderIntegral',
          query: {
            integralType: 0,
            pathType: 'newpro'
          }
        })
      } else if (this.productItem.giftstatus == 2 || this.productItem.giftstatus == 3) {
        let subjectObj = {
          subject: this.productItem.subject,
          subjectid: this.productItem.subjectid
        }
        let product = {
          comment_num: this.productItem.salenum,
          cost_price: this.productItem.costprice,
          img_path: this.productItem.image_path,
          itemid: this.productItem.itemid,
          name: this.productItem.itemname,
          sales_num: this.productItem.salenum,
          sales_price: this.productItem.saleprice
        }
        if (this.productItem.goods && Object.keys(this.productItem.goods).length > 0) {
          product = {
            comment_num: this.productItem.goods.salenum,
            cost_price: this.productItem.goods.costprice,
            img_path: this.productItem.goods.image_path,
            itemid: this.productItem.goods.itemid,
            name: this.productItem.goods.itemname,
            sales_num: this.productItem.goods.salenum,
            sales_price: this.productItem.goods.saleprice
          }
        }
        this.$store.commit('CHOOSE_TOPIC', subjectObj)
        this.$store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', [product])
        this.$router.push({
          path: '/communityevaluation',
          query: {
            pathType: 'newpro',
            applyid: this.productItem.applyid
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.newProductRecordItem {
  background: #ffffff;
  border-radius: 0.08rem;
  .time {
    .countdown {
      padding: 0.03rem 0.11rem;
      border-radius: 0.08rem 0 0.08rem 0;
      color: #ffffff;
      line-height: 0.17rem;
      p {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        margin-right: 0.04rem;
      }
      span {
        display: block;
      }
      .van-count-down {
        min-width: 0.5rem;
        color: #ffffff;
        font-size: 0.12rem;
        line-height: normal;
      }
      &.red {
        background: #fc1c39;
      }
      &.yellow {
        background: #ffb346;
      }
      &.orange {
        background: #fb6e38;
      }
    }
    > span {
      margin-right: 0.11rem;
      margin-top: 0.03rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      &.red {
        color: #fc0324;
      }
      &.yellow {
        color: #ffb346;
      }
      &.orange {
        color: #fb6e38;
      }
      &.gray {
        color: #b3b3b3;
      }
    }
  }
  .product {
    padding: 0.15rem 0.11rem;
    img {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 0.04rem;
      margin-right: 0.1rem;
    }
    .name {
      height: 0.8rem;
      position: relative;
    }
    p {
      color: #292929;
      font-weight: bold;
    }
    span {
      display: block;
      color: #6c6c6c;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    button {
      width: 0.72rem;
      height: 0.27rem;
      outline: none;
      border-radius: 0.13rem;
      color: #ffffff;
      border-style: solid;
      border-width: 0.01rem;
      position: absolute;
      right: 0;
      bottom: 0;
      &.red {
        background: #fc0324;
        border-color: #fc0324;
      }
      /*&.gray {*/
      /*  background: #B3B3B3;*/
      /*  border-color: #B3B3B3;*/
      /*}*/
      &.yellow {
        background: #ffba58;
        border-color: #ffba58;
      }
      &.yellow-border {
        background: transparent;
        border-color: #ffb346;
        color: #ffb346;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/newProductRecordItem.vue